module.exports = __webpack_public_path__ + "static/media/protein.649bff74.png";